import { formatSecondsToMinutesSeconds } from "../../../helpers/date/date-helper";

export const PatternData = ({ patternData, currentData, remainingTimeForStrass, newPiecesNumberData }) => {
  return (
    <table className="w-full">
      <thead>
      <tr>
        <th className='p-4 text-left'>Données additionnelles</th>
        <th className="p-4 text-left"/>
      </tr>
      </thead>
      <tbody>
      {
        patternData.filter((data) => data.value > 0).map((data, index) => (
          <tr key={index}>
            <td className='px-4'>{data.display_text}</td>
            <td className='px-4 text-right'>
              {
                data.name.includes('duration') ?
                  <>{currentData[data.name] ? formatSecondsToMinutesSeconds(currentData[data.name]) : '0s'}</>
                :
                data.name === 'pieces_number' ?
                  <>{newPiecesNumberData?.pieces_number ? newPiecesNumberData.pieces_number : data.value }</>
                :
                  <>
                    {currentData[data.name] ? currentData[data.name] : 0}
                    /{data.value}
                  </>
              }
            </td>
          </tr>
        ))
      }
      {remainingTimeForStrass !== null && remainingTimeForStrass !== undefined &&
        <tr>
          <td className='px-4'>Temps restant pour strasser</td>
          <td className='px-4 text-right'>{formatSecondsToMinutesSeconds(remainingTimeForStrass)}</td>
        </tr>
      }
      </tbody>
    </table>
  );
};